import { render, staticRenderFns } from "./set-restrict-register.vue?vue&type=template&id=23c97081&scoped=true"
import script from "./set-restrict-register.vue?vue&type=script&lang=js"
export * from "./set-restrict-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c97081",
  null
  
)

export default component.exports